import { render, staticRenderFns } from "./ContratosHolder.vue?vue&type=template&id=e506801a"
import script from "./ContratosHolder.vue?vue&type=script&lang=js"
export * from "./ContratosHolder.vue?vue&type=script&lang=js"
import style0 from "./ContratosHolder.vue?vue&type=style&index=0&id=e506801a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports